import { Contract } from "models"

export const getSyncStatusMessage = (
  title: string,
  contract?: Contract,
): string => {
  const syncStatus = contract?.extra_fields?.sync_status

  if (!syncStatus || syncStatus.length === 0) {
    return ''
  }

  const status = syncStatus[0].status;
  const syncedAt = syncStatus[0].synced_at;
  const isRegistered = status === 'SYNCHRONIZED' ||
    status === 'REGISTERED' ||
    status === 'PARTIALLY_REGISTERED' ||
    (status === 'SYNC_ERROR' && !!syncedAt)

  if (isRegistered) {
    return `Договор зарегистрирован в ОРД, изменение поля ${title} недоступно.`
  }

  return ''
}